export default "__VITE_ASSET__B83aRF4h__"